import { useTheme } from '@emotion/react';
import { useMemo } from 'react';

export const useActiveBrandEffect = (brandEffectEnabled = false) => {
	const { id } = useTheme();

	const activeBrandEffect = useMemo(() => {
		return brandEffectEnabled ? id : '';
	}, [brandEffectEnabled, id]);

	return activeBrandEffect;
};
